import React from 'react'
import Select from 'react-select';
import { Row, Col, Label, Input, FormFeedback, FormGroup } from 'reactstrap';
import { almas } from '../../constant/globalConstantsTypeClients'


export const FormCard = (props) => {
    let {

        section, card_code, handleInputChange,
        handleCheckChange, listDepartament, handleSelectValues, id_departaments, url_helen, name_user
    } = (props)
    console.log("🚀 ~ FormCard ~ name_user:", name_user)



    return (
        <>
            <Col sm="12" className='p-l-0 p-r-0' >

                <div className="form-section">
                    <Row className="g-4">
                        <Col sm="6">
                            <div className="user-header mb-3">
                                <div className="d-flex align-items-center user-header-content">
                                    <div className="user-avatar">
                                        {name_user?.charAt(0)}
                                    </div>

                                    <div className="user-info">
                                        <div className="user-name">
                                            {name_user}
                                        </div>
                                        <div className="user-subtitle">
                                            Configuración de toma de muestra y asignacion de secciones
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col sm="3">
                            <label className="form-label text-secondary">
                                {url_helen === almas ? "Acceso de autorización a muestreo" : "Código"}
                                <span className="text-primary ms-1">*</span>
                            </label>

                            <Input
                                type="text"
                                autoComplete="off"
                                className="form-control form-control-sm"
                                name="card_code"
                                value={card_code}
                                onChange={handleInputChange}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') e.preventDefault();
                                }}
                            />

                            <FormFeedback>Debes llenar este campo</FormFeedback>
                        </Col>

                        <Col sm="3">
                            <label className="form-label text-secondary">
                                Departamento
                                <span className="text-primary ms-1">*</span>
                            </label>

                            <Select
                                isMulti
                                name="id_departaments"
                                value={id_departaments}
                                onChange={(e) => handleSelectValues(e, "id_departaments")}
                                options={listDepartament}
                                placeholder="Selecciona uno o varios"
                                noOptionsMessage={() => "Sin opciones"}
                                isSearchable
                                classNamePrefix="select"
                            />
                        </Col>
                    </Row>
                </div>


                <hr className="my-3" />

                <h6 className="text-center text-secondary fw-semibold mb-3">
                    ÁREAS Y SECCIONES
                </h6>


                <Row className="g-4 justify-content-center">
                    {section && section.map(element => (
                        <Col md={3} lg={2} key={element.id_section}>
                            <div className="section-box">
                                <Label className="switch mb-2">
                                    <Input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={element.checkSection}
                                        onChange={(e) => handleCheckChange(e, element.id_section)}
                                    />
                                    <span className="slider round"></span>
                                </Label>

                                <span className="section-text">
                                    {element.name}
                                </span>
                            </div>
                        </Col>
                    ))}
                </Row>


            </Col>





        </>











    )
}